import LaguageSelect from './LaguageSelect';

export default LaguageSelect;
